<template>
  <input
    :id="id"
    :type="type"
    v-model="data"
    class="form-control"
    @input="emmitEvent"
    @keydown="emitKeydown"
    @change="emitChange"
    v-mask="['###-###-##-##','###-##-##-###']"
  >
</template>

<script>
import Vue from "vue";
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)
import IcInput from "./Input";
export default {
  name: "IcInputVatId",
  extends: IcInput
};
</script>

<style>
</style>
